import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaSpacing } from 'yoda-ui/yodaTheme';

export const NewStepPlaceholderStyle: (
  isDraggingOver: boolean,
  isDraggingTactic: boolean
) => SxProps<Theme> = (
  isDraggingOver,
  isDraggingTactic = false,
) => ({
  minHeight: isDraggingOver
    ? '150px'
    : isDraggingTactic ? '40px' : '20px',
  width: '100%',
  transition: 'min-height 0.2s ease-in-out',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: isDraggingOver || isDraggingTactic ? '2px dashed #0087CD' : 'none',
  borderRadius: '8px',
  margin: `0 ${YodaSpacing.small}`,
  backgroundColor: isDraggingOver || isDraggingTactic ? 'rgba(0, 135, 205, 0.1)' : 'transparent',
  alignSelf: 'stretch',
  position: 'relative',
});
